import call from "../../../shared/service/http";
import PartnerConstants from "@/packages/partner/PartnerConstants";

export default {
    namespaced: true,
    state: {
        partners: [],
    },
    mutations: {
        MUTATE: (state, payload) => {
            state[payload.state] = payload.data;
        },
    },
    getters: {
        PartnerGetter: (state) => (setup) => state[setup],
    },
    actions: {
        /**
         *
         * @param commit
         */
        partners({commit}) {
            call('get', PartnerConstants.PARTNER)
                .then(res=> {
                    if (res.data.success) {
                        commit("MUTATE", {
                            state: "partners",
                            data: res.data.data,
                        });
                    }
                    else{
                        Event.$emit("ApiError", 'Something went wrong');
                    }
                })
                .catch(err=>{
                    Event.$emit("ApiError", err.response.data.message);
                })
        },
        /**
         *
         * @param placeholder
         * @param payload
         */
        partner({dispatch}, payload) {
            call('post', PartnerConstants.PARTNER, payload)
                .then(res=> {
                    if (res.data.success) {
                        Event.$emit("ApiSuccess", res.data.message)
                        dispatch('partners')
                    }
                    else{
                        Event.$emit("ApiError", 'Something went wrong');
                    }
                })
                .catch(err=>{
                    Event.$emit("ApiError", err.response.data.message);
                })
        }
    }
}
